import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import Breadcrumbs from '@material-ui/core/Breadcrumbs';
import Typography from '@material-ui/core/Typography';

import Routes from 'Routes';

const StyledLink = styled(Link)`
  text-decoration: none;
`;

const BoothBreadcrumbs = ({ boothName }) => (
  <Breadcrumbs aria-label="breadcrumb" separator=">">
    <StyledLink to={Routes.lobby}>
      Lobby
    </StyledLink>
    <StyledLink to={Routes.hall}>
      Business and Investment Matching
    </StyledLink>
    <Typography color="textPrimary">
      {boothName}
    </Typography>
  </Breadcrumbs>
);

BoothBreadcrumbs.propTypes = {
  boothName: PropTypes.string.isRequired,
};

export default BoothBreadcrumbs;
